import styled from 'styled-components';
import { Button } from 'antd';
import theme from '../../shared/theme';

export const StyledButtonOutlined = styled(Button)`
  width: ${props => props.width || 'auto'};
  background: transparent;
  border: 2.5px solid rgb(70, 74, 201);
  color: rgb(70, 74, 201);
  font-family: Lato;
  font-size: 16px;
  font-weight: 600;
  border-radius: 32px;
  padding: 10px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
  transition: box-shadow 0.2s ease-in-out 0s;
  min-height: 40px;
  &:active {
    background: transparent;
    border: 2.5px solid rgb(70, 74, 201);
    color: rgb(70, 74, 201);
  }
  &:focus {
    background: transparent;
    border: 2.5px solid rgb(70, 74, 201);
    color: rgb(70, 74, 201);
  }
  &:hover {
    background-color: rgb(70, 74, 201);
    border: 2.5px solid rgb(64, 68, 184);
    color: rgb(255, 255, 255);
  }
  &.block-add {
    border: 2.5px solid ${theme.community.paleGrey};
    background: ${theme.community.lightGray};
    color: ${theme.community.coolGrey};
  }
`;
export const StyledButtonFilled = styled(Button)`
  width: ${props => props.width || 'auto'};
  font-family: Lato;
  font-size: 16px;
  font-weight: 600;
  border-radius: 32px;
  padding: 10px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
  transition: box-shadow 0.2s ease-in-out 0s;
  min-height: 40px;
  background-color: rgb(70, 74, 201);
  border: 2.5px solid rgb(64, 68, 184);
  color: rgb(255, 255, 255);
  &:active {
    background: transparent;
    border: 2.5px solid rgb(70, 74, 201);
    color: rgb(70, 74, 201);
  }
  &:focus {
    background: transparent;
    border: 2.5px solid rgb(70, 74, 201);
    color: rgb(70, 74, 201);
  }
  &:hover {
    background: transparent;
    border: 2.5px solid rgb(70, 74, 201);
    color: rgb(70, 74, 201);
  }
`;

export const StyledButtonDisabled = styled(Button)`
  width: ${props => props.width || 'auto'};
  font-family: Lato;
  font-size: 16px;
  font-weight: 600;
  border-radius: 32px;
  padding: 10px 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.2;
  transition: box-shadow 0.2s ease-in-out 0s;
  min-height: 40px;
  background-color: ${theme.community.lightGray};
  border: ${props =>
    props.border
      ? `${props.border} solid ${theme.community.paleGrey}`
      : `2.5px solid ${theme.community.paleGrey}`};
  background-image: none;
  color: ${theme.community.coolGrey};
  cursor: not-allowed;
  &:hover {
    border: 2.5px solid ${theme.community.paleGrey};
    background: ${theme.community.lightGray};
    color: ${theme.community.coolGrey};
  }
  &:active {
    border: 2.5px solid ${theme.community.paleGrey};
    background: ${theme.community.lightGray};
    color: ${theme.community.coolGrey};
  }
  &:focus {
    border: 2.5px solid ${theme.community.paleGrey};
    background: ${theme.community.lightGray};
    color: ${theme.community.coolGrey};
  }
`;
